// import { saveAs } from "file-saver";
import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import ScrollReveal from "../../common/components/ScrollReveal";
import Footer from "../../common/components/Footer";
import Nav from "../../common/components/Nav";
import { fetchPublicPagesByType } from "../../utils/api/cms/page";
import { errorHandler } from "../../utils/helpers/errorHandler";
// import { Link } from "react-router-dom";

const token = JSON.parse(localStorage.getItem("eko-360-p2-token"));
const rootUrl = `${process.env.REACT_APP_ROOT_URL}`;




const AnalysisPage = () => {
  const [publicAnalysis, setPublicAnalysis] = useState([]);
  const [analysis, setAnalysis] = useState([]);

  const handleFetchPublicAnalysis = async (page = 0) => {
    try {
      const data = await fetchPublicPagesByType(page, "analysis");
      setPublicAnalysis(data.data.allPages);
    } catch (error) {
      errorHandler(error, toast);
    }
  };

  useEffect(() => {
    handleFetchPublicAnalysis();
  }, []);

  useEffect(() => {
    if (publicAnalysis) {
      const filtered = publicAnalysis.filter((p) => p.type === "analysis");
      setAnalysis(filtered);
    }
  }, [publicAnalysis]);

  return (
    <div>
      <header>
        <Nav />
      </header>

      {/* Hero Banner */}
      <section style={{ background: "linear-gradient(135deg, #0C9EA9 0%, #076f78 100%)", padding: "80px 0 60px" }}>
        <div className="container text-center text-white">
          <ScrollReveal>
            <span style={{
              display: "inline-block",
              background: "rgba(255,255,255,0.15)",
              borderRadius: "20px",
              padding: "4px 16px",
              fontSize: "12px",
              fontWeight: "600",
              letterSpacing: "1.2px",
              marginBottom: "16px",
              textTransform: "uppercase",
            }}>
              Visual Analytics
            </span>
            <h1 className="fw-bold mb-3" style={{ fontSize: "clamp(1.8rem, 4vw, 2.8rem)" }}>
              Interactive Dashboards
            </h1>
            <p style={{ opacity: 0.95, maxWidth: "560px", margin: "0 auto 24px", fontSize: "15px" }}>
              Explore interactive dashboards visualizing analysis and insights across health, education and economic affairs sectors in Lagos State.
            </p>
            <div className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill"
              style={{ background: "rgba(255,255,255,0.15)" }}>
              <span style={{ fontSize: "1.4rem", fontWeight: "700" }}>{analysis.length}</span>
              <span style={{ opacity: 0.95, fontSize: "0.9rem" }}>
                Dashboard{analysis.length !== 1 ? "s" : ""} Available
              </span>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* Cards Section */}
      <section className="py-5 bg-light">
        <div className="container py-2">
          {analysis.length > 0 ? (
            <div className="row g-4">
              {analysis.map((data, idx) => (
                <div className="col-xl-4 col-md-6 d-flex" key={data.uuid || idx}>
                  <ScrollReveal className="h-100 w-100">
                    <div
                      className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden bg-white d-flex flex-column"
                      style={{ transition: "transform 0.25s ease, box-shadow 0.25s ease" }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-6px)";
                        e.currentTarget.style.boxShadow = "0 16px 40px rgba(0,0,0,0.13)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "";
                      }}
                    >
                      {/* Banner Image */}
                      <div style={{
                        height: "200px",
                        backgroundImage: `url(${process.env.REACT_APP_ROOT_URL}/uploads/${data?.banner})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }} />

                      {/* Teal Accent Bar */}
                      <div />

                      <div className="card-body p-4 d-flex flex-column">
                        <h5 className="fw-bold text-dark mb-3 fs-6">
                          {data.title}
                        </h5>
                        <div
                          className="text-black small flex-grow-1 mb-3"
                          style={{ lineHeight: "1.7" }}
                          dangerouslySetInnerHTML={{
                            __html: data.body,
                          }}
                        />
                        {data.iFrame && (
                          <a
                            href={data.iFrame}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-sm text-white rounded-2 w-100 fw-semibold mt-auto d-flex align-items-center justify-content-center gap-2"
                            style={{ backgroundColor: "#0C9EA9", border: "none", padding: "10px" }}
                          >
                            <i className="fas fa-chart-line"></i>
                            Launch Dashboard ↗
                          </a>
                        )}
                      </div>
                    </div>
                  </ScrollReveal>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-5">
              <div style={{ fontSize: "3rem", marginBottom: "16px" }}>📊</div>
              <h4 className="text-dark fw-bold">No dashboards available</h4>
              <p className="text-muted">Check back soon for interactive analysis dashboards.</p>
            </div>
          )}
        </div>
      </section>

      {/* Back to Home */}
      <section className="py-4 bg-white border-top">
        <div className="container text-center">
          <a href="/" className="btn btn-outline-dark rounded-pill px-4 fw-semibold">
            ← Back to Homepage
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AnalysisPage;

  // const handleFileDownload = async (event, dataset) => {
  //   event.preventDefault();
  //   try {
  //     const fileName = dataset.file.substr(dataset.file.lastIndexOf("/") + 1);

  //     const res = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/analysis/${fileName}/download/`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `${token}`,
  //         },
  //       }
  //     );

  //     const blob = await res.blob();
  //     saveAs(blob, dataset.title);
  //   } catch (error) {
  //     return toast.error(`An unexpected error just occured ${error.message}`);
  //   }
  // };

 